export default "__VITE_PUBLIC_ASSET__fa803427__"